/* eslint-disable camelcase */
import gql from 'graphql-tag';
import {
  Fragment_CurrentUser,
  Fragment_CurrentUser_MembershipSubscription,
  Fragment_CurrentUser_PurchasedCourses,
  Fragment_CurrentUser_InProgressCourses,
  Fragment_CurrentUser_CompletedCourses,
  Fragment_CurrentUser_Base,
  Fragment_CurrentUser_RecentClassActivity,
  Fragment_CurrentUser_RecentSeriesActivity,
  Fragment_CurrentUser_RecentMeditationActivity,
  Fragment_CurrentUser_RecentUserCreatedActivity,
  Fragment_CurrentUser_MostRecentActiveCourse,
  Fragment_CurrentUserCourse_Completion,
  Fragment_CurrentUserSubscription,
  Fragment_CurrentUserStripeInvoice,
  Fragment_CurrentUserStripeSubscription,
  Fragment_Order,
  Fragment_Playlist,
  Fragment_RegisterLiveError,
  Fragment_CurrentUserLiveRegistration,
  Fragment_CurrentUserLiveRegistrationError,
  Fragment_AllCurrentUserLiveRegistrations,
  Fragment_PageManagerSection,
  Fragment_Coupon,
  Fragment_CurrentUser_InProgressMeditations,
  Fragment_CurrentUser_InProgressClasses,
  Fragment_CurrentUser_FavoriteLibraryContent,
} from './fragments';
import {
  Fragment_ArticleCard,
  Fragment_CertificateCard,
  Fragment_ClassCard,
  Fragment_CourseCard,
  Fragment_MeditationCard,
  Fragment_ProgramCard,
  Fragment_SeriesCard,
  Fragment_TeacherCard,
  Fragment_CourseCardBigThumb,
} from './generated';

export const Mutate_EditSettings_Base = gql`
  mutation Mutate_EditSettings_Base(
    $image: Upload
    $email: String
    $first_name: String
    $last_name: String
    $address: String
    $address2: String
    $country: String
    $state: String
    $city: String
    $zip: String
    $phone: String
    $interests: [ID!]
    $experience: String
    $class_level: [ID!]
    $class_intensity: [ID!]
    $user_goals: [ID!]
    $class_goal: Int
    $meditation_goal: Int
    $is_yoga_teacher: Boolean
    $primary_language: Language
    $current_password: String
    $new_password: String
    $new_password_confirm: String
  ) {
    editSettings(
      image: $image
      email: $email
      first_name: $first_name
      last_name: $last_name
      address: $address
      address2: $address2
      country: $country
      state: $state
      city: $city
      zip: $zip
      phone: $phone
      interests: $interests
      experience: $experience
      class_level: $class_level
      class_intensity: $class_intensity
      user_goals: $user_goals
      class_goal: $class_goal
      meditation_goal: $meditation_goal
      is_yoga_teacher: $is_yoga_teacher
      primary_language: $primary_language
      current_password: $current_password
      new_password: $new_password
      new_password_confirm: $new_password_confirm
    ) {
      token
      errors
      current_user {
        ...Fragment_CurrentUser_Base
      }
    }
  }
  ${Fragment_CurrentUser_Base}
`;

// @deprecated
export const Mutate_EditSettings = gql`
  mutation Mutate_EditSettings(
    $image: Upload
    $email: String
    $first_name: String
    $last_name: String
    $address: String
    $address2: String
    $country: String
    $state: String
    $city: String
    $zip: String
    $phone: String
    $interests: [ID!]
    $experience: String
    $class_level: [ID!]
    $class_intensity: [ID!]
    $user_goals: [ID!]
    $class_goal: Int
    $meditation_goal: Int
    $is_yoga_teacher: Boolean
    $primary_language: Language
    $current_password: String
    $new_password: String
    $new_password_confirm: String
  ) {
    editSettings(
      image: $image
      email: $email
      first_name: $first_name
      last_name: $last_name
      address: $address
      address2: $address2
      country: $country
      state: $state
      city: $city
      zip: $zip
      phone: $phone
      interests: $interests
      experience: $experience
      class_level: $class_level
      class_intensity: $class_intensity
      user_goals: $user_goals
      class_goal: $class_goal
      meditation_goal: $meditation_goal
      is_yoga_teacher: $is_yoga_teacher
      primary_language: $primary_language
      current_password: $current_password
      new_password: $new_password
      new_password_confirm: $new_password_confirm
    ) {
      token
      errors
      current_user {
        ...Fragment_CurrentUser
      }
    }
  }
  ${Fragment_CurrentUser}
`;

export const Query_CurrentLocation = gql`
  query Query_CurrentLocation {
    CurrentLocation {
      ip_address
      country
      state
      zip
      currency
    }
  }
`;

// @deprecated
export const Query_CurrentUser = gql`
  query Query_CurrentUser {
    CurrentUser {
      ...Fragment_CurrentUser
    }
  }
  ${Fragment_CurrentUser}
`;

export const Query_CurrentUser_Base = gql`
  query Query_CurrentUser_Base {
    CurrentUser {
      ...Fragment_CurrentUser_Base
    }
  }
  ${Fragment_CurrentUser_Base}
`;

// @deprecated
export const Query_CurrentUser_PurchasedCourses = gql`
  query Query_CurrentUser_PurchasedCourses {
    CurrentUser {
      ...Fragment_CurrentUser_PurchasedCourses
    }
  }
  ${Fragment_CurrentUser_PurchasedCourses}
`;

// @deprecated
export const Query_CurrentUser_InProgressCourses = gql`
  query Query_CurrentUser_InProgressCourses {
    CurrentUser {
      ...Fragment_CurrentUser_InProgressCourses
    }
  }
  ${Fragment_CurrentUser_InProgressCourses}
`;

// @deprecated
export const Query_CurrentUser_InProgressMeditations = gql`
  query Query_CurrentUser_InProgressMeditations {
    CurrentUser {
      ...Fragment_CurrentUser_InProgressMeditations
    }
  }
  ${Fragment_CurrentUser_InProgressMeditations}
`;

// @deprecated
export const Query_CurrentUser_InProgressClasses = gql`
  query Query_CurrentUser_InProgressClasses {
    CurrentUser {
      ...Fragment_CurrentUser_InProgressClasses
    }
  }
  ${Fragment_CurrentUser_InProgressClasses}
`;

// @deprecated
export const Query_CurrentUser_CompletedCourses = gql`
  query Query_CurrentUser_CompletedCourses {
    CurrentUser {
      ...Fragment_CurrentUser_CompletedCourses
    }
  }
  ${Fragment_CurrentUser_CompletedCourses}
`;

export const Query_CurrentUser_allFavoritesBase = gql`
  query Query_CurrentUser_allFavoritesBase(
    $offset: Int!
    $limit: Int!
    $types: [UserFavoriteType]
  ) {
    CurrentUser_allFavorites(limit: $limit, offset: $offset, types: $types) {
      id
      content_id
    }
  }
`;

export const Query_CurrentUser_FavoritesBase = gql`
  query Query_CurrentUser_FavoritesBase($ids: [ID!]!) {
    CurrentUser_Favorites(ids: $ids) {
      id
      content_id
    }
  }
`;

export const Query_CurrentUser_Activities = gql`
  query Query_CurrentUser_Activities($ids: [ID!]!) {
    CurrentUser_Activities(ids: $ids) {
      id
      content_id
      minutes
      completion_percent
      date {
        yyyymmdd
      }
      type
    }
  }
`;

export const Query_CurrentUser_allActivities = gql`
  query Query_CurrentUser_allActivities(
    $limit: Int!
    $offset: Int!
    $types: [CurrentUser_ActivityType]
    $in_progress: Boolean
    $user_created: Boolean
  ) {
    CurrentUser_allActivities(
      limit: $limit
      offset: $offset
      types: $types
      in_progress: $in_progress
      user_created: $user_created
    ) {
      id
      content_id
      minutes
      completion_percent
      date {
        yyyymmdd
      }
      type
      content {
        ... on Class {
          ...Fragment_ClassCard
          square_image(params: { width: 100 }) {
            processed_url
          }
        }
        ... on Meditation {
          ...Fragment_MeditationCard
        }
        ... on SeriesEpisode {
          id
          title
          seasonNum
          episodeNum
          seriesSlug
          localized_path
          # we need to rename the field to avoid conflict with the media_duration field in the SeriesEpisode type
          optional_media_duration: media_duration {
            seconds
            minutes
          }
          cast
          thumbnail {
            processed_url
          }
        }
      }
    }
  }
  ${Fragment_ClassCard}
  ${Fragment_MeditationCard}
`;

// @deprecated
export const Query_CurrentUser_RecentClassActivity = gql`
  query Query_CurrentUser_RecentClassActivity {
    CurrentUser {
      ...Fragment_CurrentUser_RecentClassActivity
    }
  }
  ${Fragment_CurrentUser_RecentClassActivity}
`;

// @deprecated
export const Query_CurrentUser_RecentSeriesActivity = gql`
  query Query_CurrentUser_RecentSeriesActivity {
    CurrentUser {
      ...Fragment_CurrentUser_RecentSeriesActivity
    }
  }
  ${Fragment_CurrentUser_RecentSeriesActivity}
`;

// @deprecated
export const Query_CurrentUser_RecentMeditationActivity = gql`
  query Query_CurrentUser_RecentMeditationActivity {
    CurrentUser {
      ...Fragment_CurrentUser_RecentMeditationActivity
    }
  }
  ${Fragment_CurrentUser_RecentMeditationActivity}
`;

// @deprecated
export const Query_CurrentUser_RecentUserCreatedActivity = gql`
  query Query_CurrentUser_RecentUserCreatedActivity {
    CurrentUser {
      ...Fragment_CurrentUser_RecentUserCreatedActivity
    }
  }
  ${Fragment_CurrentUser_RecentUserCreatedActivity}
`;

// @deprecated
export const Query_CurrentUser_MostRecentActiveCourse = gql`
  query Query_CurrentUser_MostRecentActiveCourse {
    CurrentUser {
      ...Fragment_CurrentUser_MostRecentActiveCourse
    }
  }
  ${Fragment_CurrentUser_MostRecentActiveCourse}
`;

export const Query_CurrentUserBrooklynJwt = gql`
  query Query_CurrentUserBrooklynJwt {
    CurrentUserBrooklynJwt {
      jwt
    }
  }
`;

// @deprecated
export const Query_CurrentUser_Certificates = gql`
  query Query_CurrentUser_Certificates {
    CurrentUser {
      id
      completed_courses {
        course {
          ...Fragment_CertificateCard
        }
      }
    }
  }
  ${Fragment_CertificateCard}
`;

// @deprecated
export const Query_CurrentUser_MyCourses = gql`
  query Query_CurrentUser_MyCourses {
    CurrentUser {
      id
      in_progress_courses {
        recent_activity_date {
          timestamp
        }
        course {
          id
          categories {
            id
          }
          ...Fragment_CourseCard
          course_type
        }
      }
      completed_courses {
        recent_activity_date {
          timestamp
        }
        course {
          id
          categories {
            id
          }
          course_type
          ...Fragment_CourseCard
        }
      }
      purchased_courses {
        recent_activity_date {
          timestamp
        }
        course {
          id
          action_type
          categories {
            id
          }
          course_type
          ...Fragment_CourseCard
        }
      }
    }
  }
  ${Fragment_CourseCard}
`;

// @deprecated
export const Query_CurrentUser_MyPrograms = gql`
  query Query_CurrentUser_MyPrograms {
    CurrentUser {
      id
      in_progress_courses {
        recent_activity_date {
          timestamp
        }
        course {
          id
          categories {
            id
          }
          square_image(params: { width: 350 }) {
            processed_url
          }
          ...Fragment_ProgramCard
        }
      }
      completed_courses {
        recent_activity_date {
          timestamp
        }
        course {
          id
          categories {
            id
          }
          square_image(params: { width: 350 }) {
            processed_url
          }
          ...Fragment_ProgramCard
        }
      }
      purchased_courses {
        recent_activity_date {
          timestamp
        }
        course {
          id
          categories {
            id
          }
          square_image(params: { width: 350 }) {
            processed_url
          }
          ...Fragment_ProgramCard
        }
      }
    }
  }
  ${Fragment_ProgramCard}
`;

export const Query_CurrentUser_RecentActivities = gql`
  query Query_CurrentUser_RecentActivities {
    CurrentUser {
      id
      recent_activity {
        __typename
        ... on CourseActivity {
          id
          content {
            ...Fragment_CourseCard
          }
        }
        ... on SeriesActivity {
          id
          content {
            id
            seasonNum
            episodeNum
            seriesSlug
            localized_path
          }
          series {
            id
            title
            language
            localized_path
            thumbnail {
              processed_url
            }
            seasons {
              id
              episodes {
                id
              }
            }
          }
          is_new_episode
        }
      }
    }
  }
  ${Fragment_CourseCard}
`;

export const Query_CommunityCourses = gql`
  query Query_CommunityCourses($language: Language!, $offset: Int!, $limit: Int!) {
    allCourses(
      filter: { categoryId: 296, language: $language, excludeCategoryId: 272 }
      limit: $limit
      offset: $offset
      orderBy: createdAt_DESC
    ) {
      chapters {
        modules {
          entry_date {
            timestamp
          }
        }
      }
      ...Fragment_CourseCard
    }
  }
  ${Fragment_CourseCard}
`;

export const Query_Podcasts = gql`
  query Query_Podcasts($language: Language!, $offset: Int!, $limit: Int!) {
    allCourses(
      filter: { categoryId: 295, language: $language, excludeCategoryId: 272 }
      limit: $limit
      offset: $offset
      orderBy: createdAt_DESC
    ) {
      chapters {
        modules {
          entry_date {
            timestamp
          }
        }
      }
      ...Fragment_CourseCard
    }
  }
  ${Fragment_CourseCard}
`;

export const Query_CurrentUserSubscription = gql`
  query Query_CurrentUserSubscription($fetchLatest: Boolean, $useMaster: Boolean) {
    CurrentUserSubscription(fetchLatest: $fetchLatest, useMaster: $useMaster) {
      ...Fragment_CurrentUserSubscription
    }
  }
  ${Fragment_CurrentUserSubscription}
`;

export const Query_CurrentUserSubscriptionAndStripeInfo = gql`
  query Query_CurrentUserSubscriptionAndStripeInfo($fetchLatest: Boolean) {
    CurrentUserSubscription(fetchLatest: $fetchLatest) {
      ...Fragment_CurrentUserSubscription
    }

    CurrentUserStripeSubscription {
      ...Fragment_CurrentUserStripeSubscription
    }
  }
  ${Fragment_CurrentUserStripeSubscription}
  ${Fragment_CurrentUserSubscription}
`;

export const Query_CurrentUser_FavoriteTeachers = gql`
  query Query_CurrentUser_FavoriteTeachers($offset: Int!, $limit: Int!) {
    CurrentUser_allFavorites(limit: $limit, offset: $offset, types: [TEACHER]) {
      id
      content_id
      order
      created {
        timestamp
      }
      content {
        ... on Teacher {
          id
          ...Fragment_TeacherCard
        }
      }
    }
  }
  ${Fragment_TeacherCard}
`;

export const Query_CurrentUser_Favorites_Library = gql`
  query Query_CurrentUser_Favorites_Library($ids: [ID!]!) {
    CurrentUser_Favorites(ids: $ids) {
      ...Fragment_CurrentUser_FavoriteLibraryContent
    }
  }
  ${Fragment_CurrentUser_FavoriteLibraryContent}
`;
export const Query_CurrentUser_allFavorites_Library = gql`
  query Query_CurrentUser_allFavorites_Library(
    $offset: Int!
    $limit: Int!
    $types: [UserFavoriteType!]
  ) {
    CurrentUser_allFavorites(limit: $limit, offset: $offset, types: $types) {
      ...Fragment_CurrentUser_FavoriteLibraryContent
    }
  }
  ${Fragment_CurrentUser_FavoriteLibraryContent}
`;

export const Query_CurrentUser_ActivityCalendar = gql`
  query Query_CurrentUser_ActivityCalendar($start_date: DateTime!, $end_date: DateTime!) {
    CurrentUser {
      id
      activity_calendar(start_date: $start_date, end_date: $end_date) {
        class
        meditation
        date {
          timestamp
        }
      }
    }
  }
`;

// @deprecated
export const Mutate_RegisterUser = gql`
  mutation Mutate_RegisterUser(
    $first_name: String!
    $last_name: String!
    $email: String!
    $password: String!
    $registration_type: String!
    $language: Language!
    $trial_until: Int
    $trial_length: Int
    $company: String
    $url: String
  ) {
    registerUser(
      first_name: $first_name
      last_name: $last_name
      email: $email
      password: $password
      registration_type: $registration_type
      language: $language
      trial_until: $trial_until
      trial_length: $trial_length
      company: $company
      url: $url
    ) {
      token
      brooklyn_user_jwt
      errors {
        form
        first_name
        last_name
        email
        password
      }
      current_user {
        ...Fragment_CurrentUser
      }
    }
  }
  ${Fragment_CurrentUser}
`;

export const Mutate_RegisterUser_Base = gql`
  mutation Mutate_RegisterUser_Base(
    $first_name: String!
    $last_name: String!
    $email: String!
    $password: String!
    $registration_type: String!
    $language: Language!
    $trial_until: Int
    $trial_length: Int
    $company: String
    $url: String
  ) {
    registerUser(
      first_name: $first_name
      last_name: $last_name
      email: $email
      password: $password
      registration_type: $registration_type
      language: $language
      trial_until: $trial_until
      trial_length: $trial_length
      company: $company
      url: $url
    ) {
      token
      brooklyn_user_jwt
      errors {
        form
        first_name
        last_name
        email
        password
      }
      current_user {
        ...Fragment_CurrentUser_Base
      }
    }
  }
  ${Fragment_CurrentUser_Base}
`;

export const Mutate_ForgotPasswordRequest = gql`
  mutation Mutate_ForgotPasswordRequest($email: String!) {
    forgotPasswordRequest(email: $email) {
      status
      errors
    }
  }
`;

// @deprecated
export const Mutate_Login = gql`
  mutation Mutate_Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      errors
      current_user {
        ...Fragment_CurrentUser
      }
    }
  }
  ${Fragment_CurrentUser}
`;

export const Mutate_Login_Base = gql`
  mutation Mutate_Login_Base($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      errors
      current_user {
        ...Fragment_CurrentUser_Base
      }
    }
  }
  ${Fragment_CurrentUser_Base}
`;

export const Mutate_Logout = gql`
  mutation Mutate_Logout {
    logout {
      success
    }
  }
`;

export const Mutate_AddCouponToCart = gql`
  mutation Mutate_AddCouponToCart($coupon: String!, $unique_entry_ids: [ID!]!) {
    addCouponToCart(coupon: $coupon, unique_entry_ids: $unique_entry_ids) {
      errors
      total
      currency_items_total
    }
  }
`;

export const Mutate_ResetPassword = gql`
  mutation Mutate_ResetPassword(
    $resetcode: String!
    $new_password: String!
    $new_password_confirm: String!
  ) {
    resetPassword(
      resetcode: $resetcode
      new_password: $new_password
      new_password_confirm: $new_password_confirm
    ) {
      status
      errors
    }
  }
`;

export const Query_CurrentUser_FavoriteArticles = gql`
  query Query_CurrentUser_FavoriteArticles($offset: Int!, $limit: Int!) {
    CurrentUser_allFavorites(limit: $limit, offset: $offset, types: [ARTICLE]) {
      id
      content_id
      order
      created {
        timestamp
      }
      content {
        ... on Article {
          id
          square_image(params: { width: 350 }) {
            processed_url
          }
          ...Fragment_ArticleCard
        }
      }
    }
  }
  ${Fragment_ArticleCard}
`;

// @deprecated
export const Query_CurrentUser_FavoritePlaylists = gql`
  query Query_CurrentUser_FavoritePlaylists {
    CurrentUser {
      id
      favorite_playlists {
        id
        order
        created {
          timestamp
        }
        content {
          id
          ...Fragment_Playlist
        }
      }
    }
  }
  ${Fragment_Playlist}
`;

export const Query_CurrentUser_FavoriteMeditations = gql`
  query Query_CurrentUser_FavoriteMeditations($offset: Int!, $limit: Int!) {
    CurrentUser_allFavorites(limit: $limit, offset: $offset, types: [MEDITATION]) {
      id
      content_id
      order
      created {
        timestamp
      }
      content {
        ... on Meditation {
          id
          ...Fragment_MeditationCard
        }
      }
    }
  }
  ${Fragment_MeditationCard}
`;

export const Query_CurrentUser_FavoriteClasses = gql`
  query Query_CurrentUser_FavoriteClasses($offset: Int!, $limit: Int!) {
    CurrentUser_allFavorites(limit: $limit, offset: $offset, types: [CLASS]) {
      id
      content_id
      order
      created {
        timestamp
      }
      content {
        ... on Class {
          id
          square_image(params: { width: 350, format: webp }) {
            processed_url
          }
          ...Fragment_ClassCard
        }
      }
    }
  }
  ${Fragment_ClassCard}
`;

// @TODO remove duplicate param after issue resolved: github.com/yogainternational/Yoga-AWS/issues/675
export const Query_AllArticlesCategory_OfCategory = gql`
  query Query_AllArticlesCategory_OfCategory(
    $categoryId: ID!
    $articlesCategoryId: ID!
    $language: Language!
    $limit: Int = 12
  ) {
    Category(id: $categoryId, language: $language) {
      id
      name
    }
    allArticles(filter: { categoryId: $articlesCategoryId, language: $language }, limit: $limit) {
      ...Fragment_ArticleCard
    }
  }
  ${Fragment_ArticleCard}
`;

export const Query_AllCategoriesAllTeachers_OnboardingPage = gql`
  query Query_AllCategoriesAllTeachers_OnboardingPage($language: Language!) {
    yogaClassStyles: allCategories(filter: { groupId: 5 }, language: $language) {
      id
      name
      description
    }
    yogaClassLevels: allCategories(filter: { groupId: 6 }, language: $language) {
      id
      name
    }
    userGoals: allCategories(filter: { groupId: 23 }, language: $language) {
      id
      name
    }
    allTeachers(filter: { featuredTeacherOrder: true, language: $language }) {
      ...Fragment_TeacherCard
    }
  }
  ${Fragment_TeacherCard}
`;

// @TODO remove duplicate param after issue resolved: github.com/yogainternational/Yoga-AWS/issues/675
export const Query_AllClassesCategory_OfCategory = gql`
  query Query_AllClassesCategory_OfCategory(
    $categoryId: ID!
    $classesCategoryId: ID!
    $language: Language!
    $limit: Int = 12
    $offset: Int = 0
    $orderBy: ClassOrderBy
  ) {
    Category(id: $categoryId, language: $language) {
      id
      name
    }
    allClasses(
      filter: { categoryId: $classesCategoryId, language: $language }
      limit: $limit
      offset: $offset
      orderBy: $orderBy
    ) {
      ...Fragment_ClassCard
    }
  }
  ${Fragment_ClassCard}
`;

// @TODO remove duplicate param after issue resolved: github.com/yogainternational/Yoga-AWS/issues/675
export const Query_AllCoursesCategory_OfCategory = gql`
  query Query_AllCoursesCategory_OfCategory(
    $categoryId: ID!
    $coursesCategoryId: ID!
    $language: Language!
    $limit: Int = 12
    $orderBy: CourseOrderBy
  ) {
    Category(id: $categoryId, language: $language) {
      id
      name
    }
    allCourses(
      filter: { categoryId: $coursesCategoryId, language: $language, excludeCategoryId: 272 }
      limit: $limit
      orderBy: $orderBy
    ) {
      ...Fragment_CourseCard
    }
  }
  ${Fragment_CourseCard}
`;

// @TODO remove duplicate param after issue resolved: github.com/yogainternational/Yoga-AWS/issues/675
export const Query_AllMeditationsCategory_OfCategory = gql`
  query Query_AllMeditationsCategory_OfCategory(
    $categoryId: ID!
    $meditationsCategoryId: ID!
    $language: Language!
    $limit: Int = 12
    $orderBy: MeditationOrderBy
  ) {
    Category(id: $categoryId, language: $language) {
      id
      name
    }
    allMeditations(
      filter: { categoryId: $meditationsCategoryId, language: $language }
      limit: $limit
      orderBy: $orderBy
    ) {
      ...Fragment_MeditationCard
    }
  }
  ${Fragment_MeditationCard}
`;

// @TODO remove duplicate param after issue resolved: github.com/yogainternational/Yoga-AWS/issues/675
export const Query_AllProgramsCategory_OfCategory = gql`
  query Query_AllProgramsCategory_OfCategory(
    $categoryId: ID!
    $coursesCategoryId: ID!
    $language: Language!
    $limit: Int = 12
  ) {
    Category(id: $categoryId, language: $language) {
      id
      name
    }
    allCourses(
      filter: { categoryId: $coursesCategoryId, language: $language, excludeCategoryId: 272 }
      limit: $limit
    ) {
      ...Fragment_ProgramCard
    }
  }
  ${Fragment_ProgramCard}
`;

// @TODO remove duplicate param after issue resolved: github.com/yogainternational/Yoga-AWS/issues/675
export const Query_AllTeachersCategory_OfCategory = gql`
  query Query_AllTeachersCategory_OfCategory(
    $categoryId: ID!
    $teachersCategoryId: ID!
    $language: Language!
    $limit: Int = 12
  ) {
    Category(id: $categoryId, language: $language) {
      id
      name
    }
    allTeachers(filter: { categoryId: $teachersCategoryId, language: $language }, limit: $limit) {
      ...Fragment_TeacherCard
    }
  }
  ${Fragment_TeacherCard}
`;

export const Query_AllCategories_OfGroupId = gql`
  query Query_AllCategories_OfGroupId($language: Language!, $groupId: ID!) {
    allCategories(language: $language, filter: { groupId: $groupId }) {
      id
      name
    }
  }
`;

export const Query_AllTeachers_TeachersDropDown = gql`
  query Query_AllTeachers_TeachersDropDown($language: Language!) {
    allTeachers(filter: { language: $language }) {
      full_name
      image {
        processed_url
      }
    }
  }
`;

export const Query_AllTeachers_TeachersDropDown_Web = gql`
  query Query_AllTeachers_TeachersDropDown_Web($language: Language!, $limit: Int!, $offset: Int!) {
    allTeachers(filter: { language: $language }, limit: $limit, offset: $offset) {
      id
      full_name
      image {
        processed_url
      }
    }
  }
`;
export const Query_CurrentUser_AllFavorites = gql`
  query Query_CurrentUser_AllFavorites {
    CurrentUser {
      id
      favorite_classes {
        id
        order
        content {
          id
          title
          localized_path
          square_image(params: { width: 125 }) {
            processed_url
          }
          teacher {
            id
            full_name
          }
          style {
            id
            name
          }
          media_duration {
            group
            iso8601
            minutes
          }
          practiceType
          focus {
            name
          }
        }
      }
      favorite_articles {
        id
        order
        content {
          id
          title
          localized_path
          square_image(params: { width: 125 }) {
            processed_url
          }
          teacher {
            id
            full_name
          }
          topic {
            id
            name
          }
        }
      }
      favorite_meditations {
        id
        order
        content {
          id
          title
          localized_path
          square_image(params: { width: 125 }) {
            processed_url
          }
          teacher {
            id
            full_name
          }
          style {
            id
            name
          }
          media_duration {
            group
            iso8601
            minutes
          }
          practiceType
          focus {
            name
          }
        }
      }
      favorite_teachers {
        id
        order
        content {
          id
          localized_path
          full_name
          image(params: { width: 125 }) {
            processed_url
          }
          main_style {
            id
            name
          }
        }
      }
    }
  }
`;

export const Mutate_AddFavorite = gql`
  mutation Mutate_AddFavorite($content_id: ID!, $type: ToggleFavoriteType!) {
    addFavorite(content_id: $content_id, type: $type) {
      status
    }
  }
`;

export const Mutate_RemoveFavorite = gql`
  mutation Mutate_RemoveFavorite($content_id: ID!, $type: ToggleFavoriteType!) {
    removeFavorite(content_id: $content_id, type: $type) {
      status
    }
  }
`;

export const Mutate_ReorderFavorites = gql`
  mutation Mutate_ReorderFavorites($order: [ID!]!) {
    reorderFavorites(order: $order) {
      status
    }
  }
`;

// @deprecated
export const Mutate_CartCheckout = gql`
  mutation Mutate_CartCheckout(
    $is_paypal: Boolean
    $promo: String
    $basic_upgrade: Boolean
    $subscription: Boolean
    $sub_coupon_code: String
    $currency_code: String
    $order_origin: String
    $first_name: String
    $last_name: String
    $address: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $country_code: String
    $phone: String
    $stripe_token: String
    $stripe_method: String
    $stripe_initial_charge: Float
    $stripe_retry_invoice: String
    $stripe_payment_intent_id: String
    $unique_entry_ids: [ID!]
    $bundle_id: ID
    $subscription_id: ID
    $plan_id: String
    $coupon: String
    $splitit_installment_plan: String
    $card_on_file: Boolean
    $is_gaia: Boolean
    $gaia_token: String
    $display_price: String
  ) {
    cartCheckout(
      is_paypal: $is_paypal
      promo: $promo
      basic_upgrade: $basic_upgrade
      subscription: $subscription
      sub_coupon_code: $sub_coupon_code
      currency_code: $currency_code
      order_origin: $order_origin
      first_name: $first_name
      last_name: $last_name
      address: $address
      address2: $address2
      city: $city
      state: $state
      zip: $zip
      country_code: $country_code
      phone: $phone
      stripe_token: $stripe_token
      stripe_method: $stripe_method
      stripe_initial_charge: $stripe_initial_charge
      stripe_retry_invoice: $stripe_retry_invoice
      stripe_payment_intent_id: $stripe_payment_intent_id
      unique_entry_ids: $unique_entry_ids
      bundle_id: $bundle_id
      subscription_id: $subscription_id
      plan_id: $plan_id
      coupon: $coupon
      splitit_installment_plan: $splitit_installment_plan
      card_on_file: $card_on_file
      is_gaia: $is_gaia
      gaia_token: $gaia_token
      display_price: $display_price
    ) {
      current_user {
        ...Fragment_CurrentUser
      }
      token
      order {
        ...Fragment_Order
      }
      stripe_invoice {
        ...Fragment_CurrentUserStripeInvoice
      }
      stripe_subscription {
        ...Fragment_CurrentUserStripeSubscription
      }
      requires_action
      stripe_payment_intent_client_secret
      redirect
      errors
    }
  }
  ${Fragment_CurrentUser}
  ${Fragment_CurrentUserStripeInvoice}
  ${Fragment_CurrentUserStripeSubscription}
  ${Fragment_Order}
`;

export const Mutate_CartCheckout_Base = gql`
  mutation Mutate_CartCheckout_Base(
    $is_paypal: Boolean
    $promo: String
    $basic_upgrade: Boolean
    $subscription: Boolean
    $sub_coupon_code: String
    $currency_code: String
    $order_origin: String
    $first_name: String
    $last_name: String
    $address: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $country_code: String
    $phone: String
    $stripe_token: String
    $stripe_method: String
    $stripe_initial_charge: Float
    $stripe_retry_invoice: String
    $stripe_payment_intent_id: String
    $unique_entry_ids: [ID!]
    $bundle_id: ID
    $subscription_id: ID
    $plan_id: String
    $coupon: String
    $splitit_installment_plan: String
    $card_on_file: Boolean
    $is_gaia: Boolean
    $gaia_token: String
    $display_price: String
  ) {
    cartCheckout(
      is_paypal: $is_paypal
      promo: $promo
      basic_upgrade: $basic_upgrade
      subscription: $subscription
      sub_coupon_code: $sub_coupon_code
      currency_code: $currency_code
      order_origin: $order_origin
      first_name: $first_name
      last_name: $last_name
      address: $address
      address2: $address2
      city: $city
      state: $state
      zip: $zip
      country_code: $country_code
      phone: $phone
      stripe_token: $stripe_token
      stripe_method: $stripe_method
      stripe_initial_charge: $stripe_initial_charge
      stripe_retry_invoice: $stripe_retry_invoice
      stripe_payment_intent_id: $stripe_payment_intent_id
      unique_entry_ids: $unique_entry_ids
      bundle_id: $bundle_id
      subscription_id: $subscription_id
      plan_id: $plan_id
      coupon: $coupon
      splitit_installment_plan: $splitit_installment_plan
      card_on_file: $card_on_file
      is_gaia: $is_gaia
      gaia_token: $gaia_token
      display_price: $display_price
    ) {
      current_user {
        ...Fragment_CurrentUser_Base
      }
      token
      order {
        ...Fragment_Order
      }
      stripe_invoice {
        ...Fragment_CurrentUserStripeInvoice
      }
      stripe_subscription {
        ...Fragment_CurrentUserStripeSubscription
      }
      requires_action
      stripe_payment_intent_client_secret
      redirect
      errors
    }
  }
  ${Fragment_CurrentUser_Base}
  ${Fragment_CurrentUserStripeInvoice}
  ${Fragment_CurrentUserStripeSubscription}
  ${Fragment_Order}
`;

export const Mutate_CreateSubscription = gql`
  mutation Mutate_CreateSubscription(
    $subscription: Boolean
    $sub_coupon_code: String
    $currency_code: String
    $order_origin: String
    $first_name: String
    $last_name: String
    $address: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $country_code: String
    $phone: String
    $stripe_token: String
    $stripe_method: String
    $stripe_initial_charge: Float
    $stripe_retry_invoice: String
    $stripe_payment_intent_id: String
    $unique_entry_ids: [ID!]
    $bundle_id: ID
    $plan_id: String
    $vc_token: String!
    $coupon: String
    $splitit_installment_plan: String
    $card_on_file: Boolean
    $is_gaia: Boolean
    $gaia_token: String
    $test_payment_decline: Boolean
    $test_plan_override: String
    $display_price: String
  ) {
    createSubscription(
      subscription: $subscription
      sub_coupon_code: $sub_coupon_code
      currency_code: $currency_code
      order_origin: $order_origin
      first_name: $first_name
      last_name: $last_name
      address: $address
      address2: $address2
      city: $city
      state: $state
      zip: $zip
      country_code: $country_code
      phone: $phone
      stripe_token: $stripe_token
      stripe_method: $stripe_method
      stripe_initial_charge: $stripe_initial_charge
      stripe_retry_invoice: $stripe_retry_invoice
      stripe_payment_intent_id: $stripe_payment_intent_id
      unique_entry_ids: $unique_entry_ids
      bundle_id: $bundle_id
      plan_id: $plan_id
      vc_token: $vc_token
      coupon: $coupon
      splitit_installment_plan: $splitit_installment_plan
      card_on_file: $card_on_file
      is_gaia: $is_gaia
      gaia_token: $gaia_token
      test_payment_decline: $test_payment_decline
      test_plan_override: $test_plan_override
      display_price: $display_price
    ) {
      ... on CreateSubscriptionError {
        error_code
        message
      }

      ... on CreateSubscriptionSuccess {
        token
        gaia_id
        order {
          ...Fragment_Order
        }
        subscription {
          created_at
          next_assessment_at
          next_assessment_amount
          is_trial
          status
          account_id
        }
      }
    }
  }
  ${Fragment_Order}
`;

export const Mutate_CreatePaymentAndSubscription = gql`
  mutation Mutate_CreatePaymentAndSubscription(
    $subscription: Boolean
    $sub_coupon_code: String
    $currency_code: String
    $order_origin: String
    $first_name: String
    $last_name: String
    $address: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $country_code: String
    $phone: String
    $stripe_token: String
    $stripe_method: String
    $stripe_initial_charge: Float
    $stripe_retry_invoice: String
    $stripe_payment_intent_id: String
    $unique_entry_ids: [ID!]
    $bundle_id: ID
    $plan_id: String
    $vc_token: String!
    $utm_query_string: String
    $coupon: String
    $splitit_installment_plan: String
    $card_on_file: Boolean
    $is_gaia: Boolean
    $gaia_token: String
    $test_payment_decline: Boolean
    $test_plan_override: String
    $display_price: String
    $encrypted_card_number: String!
    $encrypted_expiry_month: String!
    $encrypted_expiry_year: String!
    $encrypted_security_code: String!
    $holderName: String!
    $type: String!
    $shopper_reference: String!
    $reference: String!
    $auth_uuid: String!
    $feature_flags: [String!]
  ) {
    createPaymentAndSubscription(
      subscription: $subscription
      sub_coupon_code: $sub_coupon_code
      currency_code: $currency_code
      order_origin: $order_origin
      first_name: $first_name
      last_name: $last_name
      address: $address
      address2: $address2
      city: $city
      state: $state
      zip: $zip
      country_code: $country_code
      phone: $phone
      stripe_token: $stripe_token
      stripe_method: $stripe_method
      stripe_initial_charge: $stripe_initial_charge
      stripe_retry_invoice: $stripe_retry_invoice
      stripe_payment_intent_id: $stripe_payment_intent_id
      unique_entry_ids: $unique_entry_ids
      bundle_id: $bundle_id
      plan_id: $plan_id
      vc_token: $vc_token
      utm_query_string: $utm_query_string
      coupon: $coupon
      splitit_installment_plan: $splitit_installment_plan
      card_on_file: $card_on_file
      is_gaia: $is_gaia
      gaia_token: $gaia_token
      test_payment_decline: $test_payment_decline
      test_plan_override: $test_plan_override
      display_price: $display_price
      encrypted_card_number: $encrypted_card_number
      encrypted_expiry_month: $encrypted_expiry_month
      encrypted_expiry_year: $encrypted_expiry_year
      encrypted_security_code: $encrypted_security_code
      holderName: $holderName
      type: $type
      shopper_reference: $shopper_reference
      reference: $reference
      auth_uuid: $auth_uuid
      feature_flags: $feature_flags
    ) {
      ... on CreatePaymentAndSubscriptionError {
        error_code
        message
        auth_status
        create_payment_result_code
      }

      ... on CreatePaymentAndSubscriptionSuccess {
        plan_sku
        currency_code
        checkout_uuid
        token
        gaia_id
        auth_status
        subscription {
          created_at
          next_assessment_at
          next_assessment_amount
          is_trial
          status
          account_id
        }
        order {
          ...Fragment_Order
        }
      }
    }
  }
  ${Fragment_Order}
`;

export const Mutate_FinishPaymentAndSubscription = gql`
  mutation Mutate_FinishPaymentAndSubscription(
    $order_id: String!
    $poll_count: Int!
    $third_party_name: String
    $unique_entry_ids: [ID!]
    $brooklyn_user_jwt: String!
    $checkout_uuid: String!
    $plan_sku: String!
    $currency_code: String!
  ) {
    finishPaymentAndSubscription(
      order_id: $order_id
      poll_count: $poll_count
      third_party_name: $third_party_name
      unique_entry_ids: $unique_entry_ids
      brooklyn_user_jwt: $brooklyn_user_jwt
      checkout_uuid: $checkout_uuid
      plan_sku: $plan_sku
      currency_code: $currency_code
    ) {
      success
      done
      error
      token
      gaia_id
      subscription {
        created_at
        next_assessment_at
        next_assessment_amount
        is_trial
        status
        account_id
      }
      order {
        ...Fragment_Order
      }
    }
  }
  ${Fragment_Order}
`;

export const Query_CurrentUserCurrency = gql`
  query Query_CurrentUserCurrency {
    CurrentUserCurrency {
      currency_code
    }
  }
`;

export const Query_CurrencyCurrent = gql`
  query Query_CurrencyCurrent {
    currencyCurrent {
      current_currency
      current_rate
      current_country
      is_default_currency
      not_default_currency
    }
  }
`;

export const Query_CurrencyConvert = gql`
  query Query_CurrencyConvert(
    $price: String!
    $show_symbol: Boolean
    $show_currency: Boolean
    $precision: Int
    $is_discount: Boolean
  ) {
    currencyConvert(
      price: $price
      show_symbol: $show_symbol
      show_currency: $show_currency
      precision: $precision
      is_discount: $is_discount
    )
  }
`;

export const Query_CurrentUserCourse = gql`
  query Query_CurrentUserCourse($id: ID!) {
    CurrentUserCourse(id: $id) {
      id
      is_active
      completion_percent
      is_complete
      is_purchased
      recent_activity_date {
        rss
        yyyymmdd
      }

      course {
        id
        title
        url_title
        description
        duration {
          text
        }
      }
    }
  }
`;

export const Query_CurrentUserCourseCertificate = gql`
  query Query_CurrentUserCourseCertificate($id: ID!) {
    CurrentUserCourse(id: $id) {
      id
      is_active
      completion_percent
      is_complete
      is_purchased
      recent_activity_date {
        yyyymmdd
      }

      course {
        id
        title
        ceu_count
        url_title
        description
        duration {
          text
        }
        custom_certificate {
          date_coordinates {
            x
            y
          }
          name_coordinates {
            x
            y
          }
          image {
            base64
          }
        }
      }
    }
  }
`;

export const Query_Course_CourseCertificate = gql`
  query Query_Course_CourseCertificate($id: ID!) {
    Course(id: $id) {
      id
      title
      ceu_count
      duration {
        text
      }
      custom_certificate {
        date_coordinates {
          x
          y
        }
        name_coordinates {
          x
          y
        }
        image {
          base64
        }
      }
    }
  }
`;

export const Mutate_PopulateCart = gql`
  mutation Mutate_PopulateCart($unique_entry_ids: [ID!], $bundle_id: ID, $coupon: String) {
    populateCart(unique_entry_ids: $unique_entry_ids, bundle_id: $bundle_id, coupon: $coupon) {
      total
      currency_items_total
      discount
      items {
        id
        title
        price
        original_price
        subtotal
      }
      code
      zero_decimal
      card_on_file {
        last4
        masked_card_number
        card_type
        currency_code
        payment_method_id
      }
    }
  }
`;

export const Query_AllMeditations_Latest = gql`
  query Query_AllMeditations_Latest($language: Language!) {
    allMeditations(orderBy: createdAt_DESC, limit: 12, filter: { language: $language }) {
      id
      ...Fragment_MeditationCard
    }
  }
  ${Fragment_MeditationCard}
`;

export const Query_SubmittedOrderInfo = gql`
  query Query_SubmittedOrderInfo {
    submittedOrderInfo {
      ...Fragment_Order
    }
  }
  ${Fragment_Order}
`;

export const Query_DecodeEmail = gql`
  query Query_DecodeEmail($hash: String!) {
    decodeEmail(hash: $hash)
  }
`;

export const Query_CurrentUserCourse_Completion = gql`
  query Query_CurrentUserCourse_Completion($id: ID!) {
    CurrentUserCourse(id: $id) {
      id
      ...Fragment_CurrentUserCourse_Completion
    }
  }
  ${Fragment_CurrentUserCourse_Completion}
`;

export const Query_SpecialOffers_Courses = gql`
  query Query_SpecialOffers_Courses($language: Language!) {
    SiteVars(language: $language) {
      featured_ecourses {
        ...Fragment_CourseCard
      }
    }
  }
  ${Fragment_CourseCard}
`;

export const Mutate_ValidateEmail = gql`
  mutation Mutate_ValidateEmail($email: String!) {
    validateEmail(email: $email) {
      error
    }
  }
`;

export const Mutate_LogModuleComplete = gql`
  mutation Mutate_LogModuleComplete(
    $content_id: ID!
    $section_id: ID!
    $module_id: ID!
    $percent_complete: Int!
  ) {
    logModuleComplete(
      content_id: $content_id
      section_id: $section_id
      module_id: $module_id
      percent_complete: $percent_complete
    ) {
      status
      current_user_course {
        id
        ...Fragment_CurrentUserCourse_Completion
      }
    }
  }
  ${Fragment_CurrentUserCourse_Completion}
`;

export const Mutate_SaveMediaPosition = gql`
  mutation Mutate_SaveMediaPosition(
    $content_id: ID!
    $content_type: MediaPositionContentType!
    $position_in_seconds: Int!
  ) {
    saveMediaPosition(
      content_id: $content_id
      content_type: $content_type
      position_in_seconds: $position_in_seconds
    ) {
      success
      errors
    }
  }
`;

export const Query_CurrentUserMediaPosition = gql`
  query Query_CurrentUserMediaPosition($content_id: ID!, $content_type: MediaPositionContentType!) {
    CurrentUserMediaPosition(content_id: $content_id, content_type: $content_type) {
      position_in_seconds
    }
  }
`;

export const Mutate_UpdateSubscription = gql`
  mutation Mutate_UpdateSubscription($stripe_token: String!) {
    updateSubscription(stripe_token: $stripe_token) {
      token
      error
    }
  }
`;

export const Mutate_CancelSubscription = gql`
  mutation Mutate_CancelSubscription {
    cancelSubscription {
      ... on CancelSubscriptionError {
        error_code
        message
      }
      ... on CancelSubscriptionSuccess {
        success
        token
        current_user_subscription {
          ...Fragment_CurrentUserSubscription
        }
        current_user {
          ...Fragment_CurrentUser_MembershipSubscription
        }
      }
    }
  }
  ${Fragment_CurrentUserSubscription}
  ${Fragment_CurrentUser_MembershipSubscription}
`;

// @deprecated
export const Mutate_LogConsumptionTracking = gql`
  mutation Mutate_LogConsumptionTracking(
    $row_id: ID!
    $class_id: ID!
    $minutes: Int!
    $duration: Int!
    $type: LogConsumptionTrackingType
    $practice_party_id: ID
    $playlist_id: ID
    $searchInsightsQueryID: String
    $searchInsightsIndexName: String
    $contentTitle: String
    $contentAuthor: String
    $contentTag: String
    $course_access: CourseAccess
    $module_id: ID
    $module_type: LogConsumptionTrackingType
  ) {
    logConsumptionTracking(
      row_id: $row_id
      class_id: $class_id
      minutes: $minutes
      duration: $duration
      type: $type
      practice_party_id: $practice_party_id
      playlist_id: $playlist_id
      searchInsightsQueryID: $searchInsightsQueryID
      searchInsightsIndexName: $searchInsightsIndexName
      contentTitle: $contentTitle
      contentAuthor: $contentAuthor
      contentTag: $contentTag
      course_access: $course_access
      module_id: $module_id
      module_type: $module_type
    ) {
      status
      current_user {
        ...Fragment_CurrentUser
      }
    }
  }
  ${Fragment_CurrentUser}
`;

export const Mutate_LogConsumptionTracking_Base = gql`
  mutation Mutate_LogConsumptionTracking_Base(
    $row_id: ID!
    $class_id: ID!
    $minutes: Int!
    $duration: Int!
    $type: LogConsumptionTrackingType
    $practice_party_id: ID
    $playlist_id: ID
    $searchInsightsQueryID: String
    $searchInsightsIndexName: String
    $contentTitle: String
    $contentAuthor: String
    $contentTag: String
    $course_access: CourseAccess
    $module_id: ID
    $module_type: LogConsumptionTrackingType
  ) {
    logConsumptionTracking(
      row_id: $row_id
      class_id: $class_id
      minutes: $minutes
      duration: $duration
      type: $type
      practice_party_id: $practice_party_id
      playlist_id: $playlist_id
      searchInsightsQueryID: $searchInsightsQueryID
      searchInsightsIndexName: $searchInsightsIndexName
      contentTitle: $contentTitle
      contentAuthor: $contentAuthor
      contentTag: $contentTag
      course_access: $course_access
      module_id: $module_id
      module_type: $module_type
    ) {
      status
      current_user {
        ...Fragment_CurrentUser_Base
      }
    }
  }
  ${Fragment_CurrentUser_Base}
`;

export const RN_Mutate_LogConsumptionTracking = gql`
  mutation RN_Mutate_LogConsumptionTracking(
    $row_id: ID!
    $class_id: ID!
    $minutes: Int!
    $duration: Int!
    $type: LogConsumptionTrackingType
    $searchInsightsQueryID: String
    $searchInsightsIndexName: String
    $course_access: CourseAccess
  ) {
    logConsumptionTracking(
      row_id: $row_id
      class_id: $class_id
      minutes: $minutes
      duration: $duration
      type: $type
      searchInsightsQueryID: $searchInsightsQueryID
      searchInsightsIndexName: $searchInsightsIndexName
      course_access: $course_access
    ) {
      status
    }
  }
`;

export const Mutate_LoginAsUser = gql`
  mutation Mutate_LoginAsUser($email: String!) {
    loginAsUser(email: $email) {
      token
      current_user {
        id
      }
      errors
    }
  }
`;

export const Query_CurrentUser_Permissions = gql`
  query Query_CurrentUser_Permissions {
    CurrentUser_Permissions {
      permissions
    }
  }
`;

export const Mutate_AdminChangeEmail = gql`
  mutation Mutate_AdminChangeEmail($old_email: String!, $new_email: String!) {
    adminChangeEmail(old_email: $old_email, new_email: $new_email) {
      success
      error
    }
  }
`;

export const Mutate_AdminSyncSubscription = gql`
  mutation Mutate_AdminSyncSubscription($email: String!) {
    adminSyncSubscription(email: $email) {
      success
      error
      sub_status
    }
  }
`;

export const Mutate_AdminToggleCommunityPartner = gql`
  mutation Mutate_AdminToggleCommunityPartner($email: String!, $toggle: Boolean!) {
    adminToggleCommunityPartner(email: $email, toggle: $toggle) {
      success
      error
    }
  }
`;

export const Mutate_AdminUpdateCorporateCompany = gql`
  mutation Mutate_AdminUpdateCorporateCompany($email: String!, $company: String!) {
    adminUpdateCorporateCompany(email: $email, company: $company) {
      success
      error
    }
  }
`;

export const Mutate_AdminToggleCourseAccess = gql`
  mutation Mutate_AdminToggleCourseAccess($email: String!, $course_id: ID!, $toggle: Boolean!) {
    adminToggleCourseAccess(email: $email, course_id: $course_id, toggle: $toggle) {
      success
      error
    }
  }
`;

export const Mutate_CreateMobileSubscription = gql`
  mutation Mutate_CreateMobileSubscription(
    $platform: String!
    $transaction_id: String!
    $receipt: String!
    $signature: String
    $product_id: ID
    $price: Float
    $charged: Float
  ) {
    createMobileSubscription(
      platform: $platform
      transaction_id: $transaction_id
      receipt: $receipt
      signature: $signature
      product_id: $product_id
      price: $price
      charged: $charged
    ) {
      current_user {
        ...Fragment_CurrentUser
      }
      success
      error
    }
  }
  ${Fragment_CurrentUser}
`;

export const Mutate_CreatePlaylist = gql`
  mutation Mutate_CreatePlaylist($title: String!, $description: String!) {
    createPlaylist(title: $title, description: $description) {
      status
      playlist {
        ...Fragment_Playlist
      }
    }
  }
  ${Fragment_Playlist}
`;

export const Mutate_EditPlaylist = gql`
  mutation Mutate_EditPlaylist($playlist_id: ID!, $title: String!, $description: String) {
    editPlaylist(playlist_id: $playlist_id, title: $title, description: $description) {
      status
      playlist {
        ...Fragment_Playlist
      }
    }
  }
  ${Fragment_Playlist}
`;
export const Mutate_DeletePlaylist = gql`
  mutation Mutate_DeletePlaylist($playlist_id: ID!) {
    deletePlaylist(playlist_id: $playlist_id) {
      status
      playlist {
        ...Fragment_Playlist
      }
    }
  }
  ${Fragment_Playlist}
`;

export const Mutate_AddToPlaylist = gql`
  mutation Mutate_AddToPlaylist($playlist_id: ID!, $content_id: ID!) {
    addToPlaylist(playlist_id: $playlist_id, content_id: $content_id) {
      status
      playlist {
        ...Fragment_Playlist
      }
    }
  }
  ${Fragment_Playlist}
`;

export const Mutate_CreatePlaylistAndAddItem = gql`
  mutation Mutate_CreatePlaylistAndAddItem(
    $title: String!
    $description: String
    $content_id: ID!
  ) {
    createPlaylistAndAddItem(title: $title, content_id: $content_id, description: $description) {
      status
      playlist {
        ...Fragment_Playlist
      }
    }
  }
  ${Fragment_Playlist}
`;

export const Mutate_RemoveFromPlaylist = gql`
  mutation Mutate_RemoveFromPlaylist($playlist_id: ID!, $content_id: ID!) {
    removeFromPlaylist(playlist_id: $playlist_id, content_id: $content_id) {
      status
      playlist {
        ...Fragment_Playlist
      }
    }
  }
  ${Fragment_Playlist}
`;

export const Mutate_ReorderPlaylistItems = gql`
  mutation Mutate_ReorderPlaylistItems($playlist_id: ID!, $order: [ID!]!) {
    reorderPlaylistItems(playlist_id: $playlist_id, order: $order) {
      status
    }
  }
`;

export const Mutate_InitiatePaymentPlan = gql`
  mutation Mutate_InitiatePaymentPlan(
    $unique_entry_ids: [ID!]
    $bundle_id: ID
    $currency_code: String
    $first_name: String
    $last_name: String
    $address: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $country_code: String
    $phone: String
    $coupon: String
  ) {
    initiatePaymentPlan(
      unique_entry_ids: $unique_entry_ids
      bundle_id: $bundle_id
      currency_code: $currency_code
      first_name: $first_name
      last_name: $last_name
      address: $address
      address2: $address2
      city: $city
      state: $state
      zip: $zip
      country_code: $country_code
      phone: $phone
      coupon: $coupon
    ) {
      error
      checkout_url
    }
  }
`;

export const Mutate_InitiateZuoraIframe = gql`
  mutation Mutate_InitiateZuoraIframe($pageId: String!, $uri: String!) {
    initiateZuoraIframe(pageId: $pageId, uri: $uri) {
      signature
      token
      tenantId
      key
      success
    }
  }
`;

export const Mutate_RegisterLive = gql`
  mutation Mutate_RegisterLive($content_id: String!, $zoom_id: Float!, $zoom_type: ZoomType!) {
    registerLive(content_id: $content_id, zoom_id: $zoom_id, zoom_type: $zoom_type) {
      __typename
      ...Fragment_CurrentUserLiveRegistration
      ...Fragment_RegisterLiveError
    }
  }
  ${Fragment_CurrentUserLiveRegistration}
  ${Fragment_RegisterLiveError}
`;

export const Mutate_DeleteLiveRegistration = gql`
  mutation Mutate_DeleteLiveRegistration(
    $content_id: String!
    $zoom_id: Float!
    $registrant_id: String!
    $zoom_type: ZoomType!
  ) {
    deleteLiveRegistration(
      content_id: $content_id
      zoom_id: $zoom_id
      registrant_id: $registrant_id
      zoom_type: $zoom_type
    ) {
      status_code
      message
    }
  }
`;

export const Query_CurrentUserLiveRegistration = gql`
  query Query_CurrentUserLiveRegistration($content_id: String!) {
    CurrentUserLiveRegistration(content_id: $content_id) {
      ...Fragment_CurrentUserLiveRegistration
      ...Fragment_CurrentUserLiveRegistrationError
    }
  }
  ${Fragment_CurrentUserLiveRegistration}
  ${Fragment_CurrentUserLiveRegistrationError}
`;

export const Query_AllCurrentUserLiveRegistrations = gql`
  query Query_AllCurrentUserLiveRegistrations {
    AllCurrentUserLiveRegistrations {
      __typename
      ...Fragment_AllCurrentUserLiveRegistrations
      ...Fragment_CurrentUserLiveRegistrationError
    }
  }
  ${Fragment_AllCurrentUserLiveRegistrations}
  ${Fragment_CurrentUserLiveRegistrationError}
`;

export const Query_CurrentUserUpload = gql`
  query Query_CurrentUserUpload($title: String!, $teacher: String!, $description: String!) {
    CurrentUserUpload(title: $title, teacher: $teacher, description: $description) {
      upload_url
    }
  }
`;

export const Query_AllMeditations_DailyMeditation = gql`
  query Query_AllMeditations_DailyMeditation($language: Language!, $width: Int = 1000) {
    allMeditations(orderBy: RANDOM, limit: 1, filter: { language: $language }) {
      id
      title
      square_image(params: { width: $width }) {
        processed_url
      }
      localized_path
    }
  }
`;

export const RN_Query_AllClasses_OfCategory = gql`
  query RN_Query_AllClasses_OfCategory(
    $categoryId: ID!
    $language: Language!
    $limit: Int!
    $orderBy: ClassOrderBy = createdAt_DESC
  ) {
    allClasses(
      filter: { categoryId: $categoryId, language: $language }
      limit: $limit
      orderBy: $orderBy
    ) {
      ...Fragment_ClassCard
    }
  }
  ${Fragment_ClassCard}
`;

export const RN_Query_AllMeditations_OfCategory = gql`
  query RN_Query_AllMeditations_OfCategory(
    $categoryId: ID!
    $language: Language!
    $limit: Int!
    $orderBy: MeditationOrderBy = createdAt_DESC
  ) {
    allMeditations(
      filter: { categoryId: $categoryId, language: $language }
      limit: $limit
      orderBy: $orderBy
    ) {
      ...Fragment_MeditationCard
    }
  }
  ${Fragment_MeditationCard}
`;

export const RN_Query_SiteVars_PromoHero = gql`
  query RN_Query_SiteVars_PromoHero($language: Language!) {
    SiteVars(language: $language) {
      hp_logged_in_image_square(params: { width: 1000 }) {
        processed_url
      }
      hp_logged_in_hero_title
      hp_logged_in_button_text
      hp_logged_in_button_url
    }
  }
`;

export const Query_FeatureFlag = gql`
  query Query_FeatureFlag($name: String!) {
    FeatureFlag(name: $name) {
      enabled
    }
  }
`;

export const Query_AllFeatureFlags = gql`
  query Query_AllFeatureFlags {
    allFeatureFlags {
      name
      enabled
      created
      updated_at
    }
  }
`;

export const Query_AllTeachers_FeaturedTeachers = gql`
  query Query_AllTeachers_FeaturedTeachers($language: Language!, $limit: Int = 100) {
    allTeachers(
      filter: { featuredTeacherOrder: true, language: $language }
      limit: $limit
      orderBy: featuredTeacherOrder_ASC
    ) {
      ...Fragment_TeacherCard
    }
  }
  ${Fragment_TeacherCard}
`;

export const RN_Query_AllArticles_Latest = gql`
  query RN_Query_AllArticles_Latest($language: Language!, $limit: Int!) {
    allArticles(orderBy: createdAt_DESC, limit: $limit, filter: { language: $language }) {
      id
      ...Fragment_ArticleCard
    }
  }
  ${Fragment_ArticleCard}
`;

export const RN_Query_CourseWhereYouLeftOffPlaceholder = gql`
  query RN_Query_CourseWhereYouLeftOffPlaceholder {
    lev162_int170: Course(id: 2355543) {
      ...Fragment_CourseCardBigThumb
    }
    lev162_int171: Course(id: 2190216) {
      ...Fragment_CourseCardBigThumb
    }
    lev162_int172: Course(id: 2515663) {
      ...Fragment_CourseCardBigThumb
    }
    lev78_int170: Course(id: 2355829) {
      ...Fragment_CourseCardBigThumb
    }
    lev78_int171: Course(id: 2705386) {
      ...Fragment_CourseCardBigThumb
    }
    lev78_int172: Course(id: 2982440) {
      ...Fragment_CourseCardBigThumb
    }
    lev79_int170: Course(id: 2355864) {
      ...Fragment_CourseCardBigThumb
    }
    lev79_int171: Course(id: 2428116) {
      ...Fragment_CourseCardBigThumb
    }
    lev79_int172: Course(id: 2486610) {
      ...Fragment_CourseCardBigThumb
    }
    lev80_int170: Course(id: 2451692) {
      ...Fragment_CourseCardBigThumb
    }
    lev80_int171: Course(id: 2558930) {
      ...Fragment_CourseCardBigThumb
    }
    lev80_int172: Course(id: 2558930) {
      ...Fragment_CourseCardBigThumb
    }
    isTeacher_int170: Course(id: 2243063) {
      ...Fragment_CourseCardBigThumb
    }
    isTeacher_int171: Course(id: 2355833) {
      ...Fragment_CourseCardBigThumb
    }
    isTeacher_int172: Course(id: 2558930) {
      ...Fragment_CourseCardBigThumb
    }
  }
  ${Fragment_CourseCardBigThumb}
`;

export const RN_Query_Article = gql`
  query RN_Query_Article($id: ID!) {
    Article(id: $id) {
      __typename
      id
      language
      title
      subtitle
      url_title
      entry_date {
        iso8601
        yyyymmdd
      }
      no_text_image(params: { width: 1600 }) {
        processed_url
      }
      square_image(params: { width: 375 }) {
        processed_url
      }
      short_summary
      seo_title
      parsed_body(params: { width: 800 })
      snippet(limit: 30000)
      language
      teacher {
        ...Fragment_TeacherCard
      }
      channel {
        id
        name
        url_title
      }
      topic {
        id
        name
        url_title
      }
      entry_type
      jwplayer_id
      brightcove_id
      media_source
      media_download
      media_duration {
        group
        iso8601
      }
      tags {
        text
        url_title
      }
      secondary_teacher {
        full_name
        image(params: { width: 244 }) {
          processed_url
        }
        about_me
        snippet
        id
        url_title
      }
      next {
        path
      }
      prev {
        path
      }
    }
  }
  ${Fragment_TeacherCard}
`;

export const RN_Query_Favorites = gql`
  query RN_Query_Favorites {
    CurrentUser {
      id
      favorite_classes {
        id
        order
        content {
          media_duration {
            group
            iso8601
            minutes
          }
          id
          title
          path
          square_image(params: { width: 125 }) {
            processed_url
          }
          teacher {
            id
            full_name
          }
          style {
            id
            name
          }
        }
      }
      favorite_articles {
        id
        order
        content {
          id
          title
          path
          square_image(params: { width: 125 }) {
            processed_url
          }
          teacher {
            id
            full_name
          }
          topic {
            id
            name
          }
        }
      }
      favorite_meditations {
        id
        order
        content {
          media_duration {
            group
            iso8601
            minutes
          }
          id
          title
          path
          square_image(params: { width: 125 }) {
            processed_url
          }
          teacher {
            id
            full_name
          }
          style {
            id
            name
          }
        }
      }
      favorite_teachers {
        id
        order
        content {
          id
          path
          full_name
          image(params: { width: 125 }) {
            processed_url
          }
          main_style {
            id
            name
          }
        }
      }
    }
  }
`;

export const RN_Query_AllClasses_Latest = gql`
  query RN_Query_AllClasses_Latest($language: Language!, $limit: Int = 6) {
    allClasses(orderBy: createdAt_DESC, limit: $limit, filter: { language: $language }) {
      id
      ...Fragment_ClassCard
    }
  }
  ${Fragment_ClassCard}
`;

export const RN_Query_Meditation = gql`
  query RN_Query_Meditation($id: ID!) {
    Meditation(id: $id) {
      __typename
      id
      language
      title
      subtitle
      full_url
      url_title
      completed_count
      entry_date {
        iso8601
        yyyymmdd
      }
      no_text_image(params: { width: 1600 }) {
        processed_url
      }
      short_summary
      seo_title
      parsed_body(params: { width: 800 })
      practiceType
      snippet(limit: 30000)
      language
      teacher {
        ...Fragment_TeacherCard
      }
      entry_type
      jwplayer_id
      brightcove_id
      media_source
      media_download
      media_duration {
        group
      }
      tags {
        text
        url_title
      }
      secondary_teacher {
        full_name
        image(params: { width: 244 }) {
          processed_url
        }
        snippet
        about_me
        id
      }
      square_image(params: { width: 375 }) {
        processed_url
      }
      next {
        path
      }
      prev {
        path
      }
      style {
        name
        url_title
      }
      focus {
        name
        url_title
      }
    }
  }
  ${Fragment_TeacherCard}
`;

export const RN_Query_AllClasses_MTL = gql`
  query RN_Query_AllClasses_MTL($language: Language!, $limit: Int = 6) {
    allClasses(
      orderBy: createdAt_DESC
      limit: $limit
      filter: { language: $language, tagId: 427 }
    ) {
      id
      ...Fragment_ClassCard
    }
  }
  ${Fragment_ClassCard}
`;

export const Query_AllLives = gql`
  query Query_AllLives(
    $language: Language!
    $orderBy: LiveOrderBy = createdAt_DESC
    $offset: Int = 0
    $limit: Int = 0
  ) {
    allLives(filter: { language: $language }, orderBy: $orderBy, offset: $offset, limit: $limit) {
      id
      title
      url_title
      path
      full_url
      localized_path
      entry_date {
        timestamp
      }
      edit_date {
        timestamp
      }
      square_image {
        processed_url
      }
      teacher {
        full_name
      }
      teachers {
        full_name
      }
      recent_minutes_watched
      start_date {
        timestamp
      }
      end_date {
        timestamp
      }
      tags {
        name
      }
      parsed_body
      snippet(limit: 100)
      language
      content {
        live_zoom {
          id
          jw_channel_id
          jw_playlist_id
          zoom_meeting_url
        }
      }
    }
  }
`;

export const Query_VisualTest_Class = gql`
  query Query_VisualTest_Class($id: ID!) {
    Class(id: $id) {
      ...Fragment_ClassCard
    }
  }
  ${Fragment_ClassCard}
`;

export const Query_VisualTest_Meditation = gql`
  query Query_VisualTest_Meditation($id: ID!) {
    Meditation(id: $id) {
      ...Fragment_MeditationCard
    }
  }
  ${Fragment_MeditationCard}
`;

export const Query_VisualTest_Article = gql`
  query Query_VisualTest_Article($id: ID!) {
    Article(id: $id) {
      ...Fragment_ArticleCard
    }
  }
  ${Fragment_ArticleCard}
`;

export const Query_VisualTest_Course = gql`
  query Query_VisualTest_Course($id: ID!) {
    Course(id: $id) {
      ...Fragment_CourseCard
    }
  }
  ${Fragment_CourseCard}
`;

export const Query_VisualTest_Program = gql`
  query Query_VisualTest_Program($id: ID!) {
    Course(id: $id) {
      ...Fragment_ProgramCard
    }
  }
  ${Fragment_ProgramCard}
`;

export const Query_VisualTest_Teacher = gql`
  query Query_VisualTest_Teacher($id: ID!) {
    Teacher(id: $id) {
      ...Fragment_TeacherCard
    }
  }
  ${Fragment_TeacherCard}
`;

export const Query_VisualTest_Certificate = gql`
  query Query_VisualTest_Certificate($id: ID!) {
    Course(id: $id) {
      ...Fragment_CertificateCard
    }
  }
  ${Fragment_CertificateCard}
`;

export const RN_Query_MTLCourse = gql`
  query RN_Query_MTLCourse($id: ID!) {
    Course(id: $id) {
      id
      full_url
      permissions
      chapters {
        modules {
          id
          display_name
          module_type
          quiz_or_live_embed
          snippet(limit: 600)
        }
      }
    }
  }
`;

export const Query_MTLCourse = gql`
  query Query_MTLCourse($id: ID!) {
    Course(id: $id) {
      id
      localized_path
      permissions
      chapters {
        modules {
          display_name
          module_type
          quiz_or_live_embed
          snippet(limit: 600)
        }
      }
    }
  }
`;

export const Query_CurrentUserTwilio = gql`
  query Query_CurrentUserTwilio($roomName: String!) {
    CurrentUserTwilio(roomName: $roomName) {
      token
    }
  }
`;

// @TODO
// export const Query_CurrentUserAgora = gql`
//   query Query_CurrentUserAgora($roomName: String!) {
//     CurrentUserAgora(roomName: $roomName) {
//       token
//       screen_share_token
//     }
//   }
// `;

export const Mutation_StreamActivityAddComment = gql`
  mutation Mutation_StreamActivityAddComment(
    $activityID: String!
    $commentInfo: StreamActivityCommentInfo!
    $feedID: String!
  ) {
    StreamActivityAddComment(activityID: $activityID, commentInfo: $commentInfo, feedID: $feedID) {
      newComment {
        activity_id
        created_at
        data {
          text
        }
        id
        kind
        parent
        user {
          data {
            image
            name
          }
        }
        user_id
      }
    }
  }
`;

export const Query_StreamActivityID = gql`
  query Query_StreamActivityID($entryID: String!, $entryType: String!) {
    StreamActivityID(entryID: $entryID, entryType: $entryType) {
      activityID
    }
  }
`;

export const Query_CurrentUserStreamActivityToken = gql`
  query Query_CurrentUserStreamActivityToken {
    CurrentUserStreamActivityToken {
      token
    }
  }
`;

export const Query_CurrentUserStreamChat = gql`
  query Query_CurrentUserStreamChat {
    CurrentUserStreamChat {
      token
    }
  }
`;

export const Query_AllCourses_Creator_Classes = gql`
  query Query_AllCourses_Creator_Classes($language: Language!) {
    allCourses(
      orderBy: createdAt_DESC
      limit: 12
      filter: { language: $language, categoryId: "1reXMKmsH0KZCj26OO7433" }
    ) {
      ...Fragment_CourseCard
    }
  }
  ${Fragment_CourseCard}
`;

export const Query_AllPlaylists = gql`
  query Query_AllPlaylists {
    allPlaylists {
      ...Fragment_Playlist
    }
  }
  ${Fragment_Playlist}
`;

export const Query_YIPlaylists = gql`
  query Query_YIPlaylists {
    YIPlaylists {
      ...Fragment_Playlist
    }
  }
  ${Fragment_Playlist}
`;

export const Query_Playlist = gql`
  query Query_Playlist($id: ID!) {
    Playlist(id: $id) {
      ...Fragment_Playlist
    }
  }
  ${Fragment_Playlist}
`;

export const Query_PlayList_PlaylistPlayer = gql`
  query Query_PlayList_PlaylistPlayer($id: ID!) {
    Playlist(id: $id) {
      id
      items {
        content {
          title
          full_url
          url_title
          localized_path
          square_image(params: { width: 125 }) {
            processed_url
          }
        }
      }
    }
  }
`;

export const Query_AllCourses_Programs = gql`
  query Query_AllCourses_Programs($language: Language!, $limit: Int!) {
    allCourses(
      orderBy: createdAt_DESC
      filter: { language: $language, categoryId: 274, excludeCategoryId: 272 }
      limit: $limit
    ) {
      id
      title
      categories {
        name
      }
      square_image(params: { width: 350 }) {
        processed_url
      }
      localized_path
    }
  }
`;

export const Query_SiteVars_CommunityUpcomingCourses = gql`
  query Query_SiteVars_CommunityUpcomingCourses($language: Language!) {
    SiteVars(language: $language) {
      community_upcoming_courses {
        ...Fragment_CourseCard
      }
    }
  }
  ${Fragment_CourseCard}
`;
export const Query_SiteVars_CommunityFeaturedCourses = gql`
  query Query_SiteVars_Community_Featured_Courses($language: Language!) {
    SiteVars(language: $language) {
      community_featured_courses {
        ...Fragment_CourseCard
      }
    }
  }
  ${Fragment_CourseCard}
`;
export const Query_SiteVars_CommunityFeaturedTeachers = gql`
  query Query_SiteVars_Community_Featured_Teachers($language: Language!) {
    SiteVars(language: $language) {
      community_featured_teachers {
        ...Fragment_TeacherCard
      }
    }
  }
  ${Fragment_TeacherCard}
`;

export const Mutate_UpdateSubscriptionOffer = gql`
  mutation Mutate_UpdateSubscriptionOffer($offer: SubscriptionOffer!) {
    updateSubscriptionOffer(offer: $offer) {
      success
      error
      current_user {
        ...Fragment_CurrentUser_MembershipSubscription
      }
      current_user_subscription {
        ...Fragment_CurrentUserSubscription
      }
    }
  }
  ${Fragment_CurrentUserSubscription}
  ${Fragment_CurrentUser_MembershipSubscription}
`;

export const Mutate_UpdatePaymentMethod = gql`
  mutation Mutate_UpdatePaymentMethod(
    $paymentMethodId: String!
    $country: String!
    $postalCode: String!
  ) {
    updatePaymentMethod(
      paymentMethodId: $paymentMethodId
      country: $country
      postalCode: $postalCode
    ) {
      ... on UpdatePaymentMethodError {
        error_code
        message
      }

      ... on UpdatePaymentMethodSuccess {
        token
        current_user_subscription {
          ...Fragment_CurrentUserSubscription
        }
      }
    }
  }
  ${Fragment_CurrentUserSubscription}
`;

export const Mutate_UpdateAdyenPaymentMethod = gql`
  mutation Mutate_UpdateAdyenPaymentMethod(
    $country: String!
    $postalCode: String!
    $encrypted_card_number: String!
    $encrypted_expiry_month: String!
    $encrypted_expiry_year: String!
    $encrypted_security_code: String!
    $holder_name: String!
    $currency: String!
    $type: String!
    $shopper_reference: String!
    $reference: String!
    $auth_uuid: String!
    $vc_token: String!
  ) {
    updateAdyenPaymentMethod(
      country: $country
      postalCode: $postalCode
      encrypted_card_number: $encrypted_card_number
      encrypted_expiry_month: $encrypted_expiry_month
      encrypted_expiry_year: $encrypted_expiry_year
      encrypted_security_code: $encrypted_security_code
      holder_name: $holder_name
      currency: $currency
      type: $type
      shopper_reference: $shopper_reference
      reference: $reference
      auth_uuid: $auth_uuid
      vc_token: $vc_token
    ) {
      ... on UpdateAdyenPaymentMethodError {
        error_code
        message
        auth_status
      }

      ... on UpdateAdyenPaymentMethodSuccess {
        token
        auth_status
        current_user_subscription {
          ...Fragment_CurrentUserSubscription
        }
      }
    }
  }
  ${Fragment_CurrentUserSubscription}
`;

export const Query_CurrentUser_CourierPreferences = gql`
  query Query_CurrentUser_CourierPreferences($includeTestCategories: Boolean) {
    CurrentUserCourier {
      preferences(includeTestCategories: $includeTestCategories) {
        id
        title
        status
        type
        notifications {
          id
          title
          status
        }
      }
    }
  }
`;

export const Query_CurrentUser_CourierSignature = gql`
  query Query_CurrentUser_CourierSignature {
    CurrentUserCourier {
      signature
    }
  }
`;

export const Mutate_UpdateCourierUserPreferences = gql`
  mutation Mutate_UpdateCourierUserPreferences(
    $status: CourierStatus!
    $categoryIds: [String]
    $notificationIds: [String]
  ) {
    updateCourierUserPreferences(
      status: $status
      categoryIds: $categoryIds
      notificationIds: $notificationIds
    ) {
      success
    }
  }
`;

export const Query_Course_CoursePlayerPageRN = gql`
  query Query_Course_CoursePlayerPageRN($id: ID!) {
    Course(id: $id) {
      __typename
      id
      title
      subtitle
      url_title
      description
      short_description
      permissions
      full_url
      image(params: { width: 760 }) {
        processed_url
      }
      categories {
        id
        name
      }
      hubspot_form_id
      sales_page_select {
        background_video
        lead_image(params: { width: 1600 }) {
          processed_url
        }
        caption_title
        caption_body
        jwplayer_id
        brightcove_id
        buttons {
          id
          text
          url
          alt_text
          disabled
          price
        }
        countdown {
          timestamp
          rss
          yyyymmdd
        }
        countdown_text
        banner {
          url
        }
        benefits {
          id
          body
          url
          size
          text
        }
        faq {
          question
          answer
        }
        duration
        sections {
          id
          body
        }
      }
      ecourse_price
      a_la_carte_price
      address_needed
      email_receipt
      upcoming_block
      upcoming_until {
        iso8601
        timestamp
        yyyymmdd
        rss
      }
      language
      no_text_image(params: { width: 1800 }) {
        processed_url
      }
      teachers {
        localized_path
        id
        full_name
        about_me
        snippet
        url_title
        image(params: { width: 244 }) {
          url
          alt_text
          processed_url
        }
      }
      permissions
      units {
        id
        name
        chapters {
          id
          name
          modules {
            id
            display_name
            snippet(limit: 600)
            module_type
            media_duration {
              seconds
            }
          }
        }
      }
      chapters {
        id
        name
        modules {
          id
          display_name
          module_type
          quiz_or_live_embed
          file
          jwplayer_id
          brightcove_id
          article_title
          article_subtitle
          article_body
          snippet(limit: 600)
          media_duration {
            seconds
          }
          media_download
          media_source
        }
      }
    }
  }
`;

export const Mutate_CreateGaiaAccount = gql`
  mutation Mutate_CreateGaiaAccount {
    createGaiaAccount {
      success
      error
    }
  }
`;

export const Mutate_AuthorizeAdyen = gql`
  mutation Mutate_AuthorizeAdyen(
    $currency: String!
    $vc_token: String!
    $country: String
    $locale: String
    $pageName: String!
    $brooklyn_user_jwt: String
  ) {
    authorizeAdyen(
      currency: $currency
      vc_token: $vc_token
      country: $country
      locale: $locale
      pageName: $pageName
      brooklyn_user_jwt: $brooklyn_user_jwt
    ) {
      payment_method {
        brands
        name
        type
        configuration {
          merchantId
          intent
        }
      }
      shopper_reference
      reference
      auth_uuid
    }
  }
`;

export const Mutate_UpdateAdyenRecord = gql`
  mutation Mutate_UpdateAdyenRecord(
    $auth_uuid: String!
    $discarded: Boolean
    $billing_account_created: Boolean
  ) {
    updateAdyenRecord(
      auth_uuid: $auth_uuid
      discarded: $discarded
      billing_account_created: $billing_account_created
    ) {
      success
    }
  }
`;

export const Mutate_CreateAdyenPayment = gql`
  mutation Mutate_CreateAdyenPayment(
    $encrypted_card_number: String
    $encrypted_expiry_month: String
    $encrypted_expiry_year: String
    $encrypted_security_code: String
    $type: String!
    $plan_id: String!
    $shopper_reference: String!
    $reference: String!
    $auth_uuid: String!
    $country_code: String!
    $currency_code: String!
    $vc_token: String!
  ) {
    createAdyenPayment(
      encrypted_card_number: $encrypted_card_number
      encrypted_expiry_month: $encrypted_expiry_month
      encrypted_expiry_year: $encrypted_expiry_year
      encrypted_security_code: $encrypted_security_code
      type: $type
      plan_id: $plan_id
      shopper_reference: $shopper_reference
      reference: $reference
      auth_uuid: $auth_uuid
      country_code: $country_code
      currency_code: $currency_code
      vc_token: $vc_token
    ) {
      pspReference
      resultCode
      action {
        paymentData
        paymentMethodType
        sdkData {
          token
        }
        action_type
      }
    }
  }
`;

export const Mutate_CreateThirdPartySubscription = gql`
  mutation Mutate_CreateThirdPartySubscription(
    $billingToken: String
    $facilitatorAccessToken: String
    $orderID: String
    $payerID: String
    $paymentID: String
    $paymentSource: String
    $paymentData: String
    $currency_code: String
    $plan_id: String
    $unique_entry_ids: [ID!]
    $auth_uuid: String
    $country_code: String
    $bundle_id: String
    $coupon: String
    $display_price: String
    $order_origin: String
    $shopper_reference: String!
    $reference: String!
    $test_payment_decline: Boolean
    $test_plan_override: String
    $vc_token: String!
    $utm_query_string: String
    $feature_flags: [String!]
  ) {
    createThirdPartySubscription(
      billingToken: $billingToken
      facilitatorAccessToken: $facilitatorAccessToken
      orderID: $orderID
      payerID: $payerID
      paymentID: $paymentID
      paymentSource: $paymentSource
      paymentData: $paymentData
      currency_code: $currency_code
      plan_id: $plan_id
      unique_entry_ids: $unique_entry_ids
      auth_uuid: $auth_uuid
      country_code: $country_code
      bundle_id: $bundle_id
      coupon: $coupon
      display_price: $display_price
      order_origin: $order_origin
      shopper_reference: $shopper_reference
      reference: $reference
      test_plan_override: $test_plan_override
      test_payment_decline: $test_payment_decline
      vc_token: $vc_token
      utm_query_string: $utm_query_string
      feature_flags: $feature_flags
    ) {
      ... on CreatePaymentAndSubscriptionError {
        error_code
        message
        auth_status
        create_payment_result_code
      }

      ... on CreatePaymentAndSubscriptionSuccess {
        plan_sku
        currency_code
        checkout_uuid
        token
        gaia_id
        auth_status
        subscription {
          created_at
          next_assessment_at
          next_assessment_amount
          is_trial
          status
          account_id
        }
        order {
          ...Fragment_Order
        }
      }
    }
  }
  ${Fragment_Order}
`;

export const Mutate_UpdateThirdPartyPaymentMethod = gql`
  mutation Mutate_UpdateThirdPartyPaymentMethod(
    $billingToken: String
    $facilitatorAccessToken: String
    $orderID: String
    $payerID: String
    $paymentID: String
    $paymentSource: String
    $paymentData: String
    $country_code: String
    $shopper_reference: String!
    $auth_uuid: String!
    $vc_token: String!
  ) {
    updateThirdPartyPaymentMethod(
      billingToken: $billingToken
      facilitatorAccessToken: $facilitatorAccessToken
      orderID: $orderID
      payerID: $payerID
      paymentID: $paymentID
      paymentSource: $paymentSource
      paymentData: $paymentData
      country_code: $country_code
      shopper_reference: $shopper_reference
      auth_uuid: $auth_uuid
      vc_token: $vc_token
    ) {
      ... on UpdateAdyenPaymentMethodError {
        error_code
        message
        auth_status
      }
      ... on UpdateAdyenPaymentMethodSuccess {
        token
        auth_status
        current_user_subscription {
          ...Fragment_CurrentUserSubscription
        }
      }
    }
  }
  ${Fragment_CurrentUserSubscription}
`;

export const Mutate_DeleteUserAccountData = gql`
  mutation Mutate_DeleteUserAccountData($email: String!) {
    deleteUserAccountData(email: $email) {
      success
    }
  }
`;

export const Query_HomepageLoggedInHeroContent = gql`
  query Query_HomepageLoggedInHeroContent($language: Language, $platform: SiteVars_Platform) {
    SiteVars(language: $language, platform: $platform) {
      hp_logged_in_hero_content {
        desktop_xl_image {
          processed_url
        }
        desktop_image {
          processed_url
        }
        tablet_image {
          processed_url
        }
        square_image {
          processed_url
        }
        visible_to
        hero_content {
          content_id
          content_type
          content_url
          overlay_text
        }
        hero_content_v2 {
          ... on HeroContent {
            content_id
            content_type
            content_url
            overlay_text
          }
          ... on HomepageHeroContent_CustomUrl {
            url
            id
            overlay_text
          }
        }
      }
    }
  }
`;

export const Query_FeaturedClassesCarousel = gql`
  query Query_FeaturedClassesCarousel($language: Language!) {
    SiteVars(language: $language) {
      featured_classes {
        ...Fragment_ClassCard
      }
    }
  }
  ${Fragment_ClassCard}
`;

export const Mutate_RecaptchaVerification = gql`
  mutation Mutate_RecaptchaVerification($token: String!) {
    recaptchaVerification(token: $token) {
      is_verified
    }
  }
`;

export const Query_BrightcoveMedia = gql`
  query Query_BrightcoveMedia($brightcoveId: String!, $useByteRange: Boolean) {
    BrightcoveMedia(brightcoveId: $brightcoveId, useByteRange: $useByteRange) {
      test
    }
  }
`;

export const Query_SeriesEpisode_Mobile = gql`
  query Query_SeriesEpisode_Mobile($id: ID!, $heroWidth: Int = 1600, $thumbWidth: Int = 375) {
    SeriesEpisode(id: $id) {
      id
      seasonNum
      episodeNum
      title
      media {
        brightcove_id
      }
      media_duration {
        seconds
        minutes
      }
      cast
      hero(params: { width: $heroWidth }) {
        processed_url
      }
      thumbnail(params: { width: $thumbWidth }) {
        processed_url
      }
      trailer {
        brightcove_id
      }
      description
      short_description
    }
  }
`;

export const Query_AllSeries_Mobile = gql`
  query Query_AllSeries_Mobile($language: Language!) {
    allSeries(filter: { language: $language }) {
      id
      ...Fragment_SeriesCard
    }
  }
  ${Fragment_SeriesCard}
`;

export const Query_CurrentUserSeriesCompletion = gql`
  query Query_CurrentUserSeriesCompletion($series_id: ID!) {
    CurrentUserSeriesCompletion(series_id: $series_id) {
      watchedEpisodes {
        id
        is_complete
        position_in_seconds
      }
    }
  }
`;

export const Query_CurrentUser_ContinueWhereYouLeftOff = gql`
  query Query_CurrentUser_ContinueWhereYouLeftOff($locale: String!) {
    CurrentUser_ContinueWhereYouLeftOff(locale: $locale) {
      activeViewIdx
      views {
        name
        contentList {
          __typename
          ... on SeriesActivity {
            id
            content {
              id
              seasonNum
              episodeNum
              seriesSlug
              localized_path
            }
            series {
              id
              title
              language
              localized_path
              thumbnail {
                processed_url
              }
              seasons {
                id
                episodes {
                  id
                }
              }
            }
            is_new_episode
          }
          ... on CourseActivity {
            id
            content {
              ...Fragment_CourseCard
            }
          }
          ... on ClassActivity {
            id
            content {
              ...Fragment_ClassCard
            }
          }
          ... on MeditationActivity {
            id
            content {
              ...Fragment_MeditationCard
            }
          }
        }
      }
    }
  }
  ${Fragment_CourseCard}
  ${Fragment_ClassCard}
  ${Fragment_MeditationCard}
`;

export const Query_CurrentUser_ContinueWatchingSeries = gql`
  query Query_CurrentUser_ContinueWatchingSeries($seriesId: ID!) {
    CurrentUser_ContinueWatchingSeries(seriesId: $seriesId) {
      episode {
        id
        title
        seasonNum
        episodeNum
        seriesSlug
        localized_path
        media_duration {
          seconds
          minutes
        }
        cast
        thumbnail {
          processed_url
        }
        media {
          brightcove_id
        }
      }
      position_in_seconds
    }
  }
`;

export const Query_Promo_TimeLimits = gql`
  query Query_Promo_TimeLimits($id: ID!) {
    MemberPromo(id: $id) {
      id
      countdown_text
      end_time {
        iso8601
      }
    }
  }
`;

export const Query_ClientVersion = gql`
  query Query_ClientVersion($client_version_info: ClientVersionInfo!) {
    ClientVersion(client_version_info: $client_version_info) {
      is_retired
      platform
      version
    }
  }
`;

export const Query_AllRedirects = gql`
  query Query_AllRedirects(
    $limit: Int
    $offset: Int
    $where: Where
    $requestFeatureFlags: [RequestFeatureFlag!]
  ) {
    allRedirects(
      limit: $limit
      offset: $offset
      where: $where
      requestFeatureFlags: $requestFeatureFlags
    ) {
      id
      from_path
      to_path
      created {
        iso8601
      }
    }
  }
`;

export const Mutate_CreateRedirect = gql`
  mutation Mutate_CreateRedirect($path: String!, $redirect_to: String!) {
    createRedirect(path: $path, redirect_to: $redirect_to) {
      success
    }
  }
`;

export const Mutate_DeleteRedirect = gql`
  mutation Mutate_DeleteRedirect($path: String!) {
    deleteRedirect(path: $path) {
      success
    }
  }
`;

export const Mutate_CreatePageManagerSection = gql`
  mutation Mutate_CreatePageManagerSection(
    $type: PageManagerSectionType!
    $language: Language!
    $internal_name: String!
  ) {
    createPageManagerSection(type: $type, language: $language, internal_name: $internal_name) {
      success
    }
  }
`;

export const Mutate_UpdatePageManagerSection = gql`
  mutation Mutate_UpdatePageManagerSection(
    $section_id: ID!
    $internal_name: String
    $fields: FieldsByPageManagerSectionType
  ) {
    updatePageManagerSection(
      section_id: $section_id
      internal_name: $internal_name
      fields: $fields
    ) {
      success
    }
  }
`;

export const Mutate_DeletePageManagerSection = gql`
  mutation Mutate_DeletePageManagerSection($section_id: ID!) {
    deletePageManagerSection(section_id: $section_id) {
      success
    }
  }
`;

export const Query_PageManagerSection = gql`
  query Query_PageManagerSection(
    $id: ID
    $reference_id: ID
    $language: Language
    $content_list_include_missing: Boolean
  ) {
    PageManagerSection(id: $id, reference_id: $reference_id, language: $language) {
      ...Fragment_PageManagerSection
    }
  }
  ${Fragment_PageManagerSection}
`;

export const Query_AllPageManagerSections = gql`
  query Query_AllPageManagerSections(
    $type: PageManagerSectionType
    $where_internal_name_like: String
    $limit: Int
    $offset: Int
    $feature_flags: [String!]
    $content_list_include_missing: Boolean
  ) {
    allPageManagerSections(
      type: $type
      where_internal_name_like: $where_internal_name_like
      limit: $limit
      offset: $offset
      feature_flags: $feature_flags
    ) {
      ...Fragment_PageManagerSection
    }
  }
  ${Fragment_PageManagerSection}
`;

export const Query_AllPageManagerRoots = gql`
  query Query_AllPageManagerRoots {
    allPageManagerRoots {
      id
      location_id
      language
    }
  }
`;

export const Query_PageManagerRoot_WithSections = gql`
  query Query_PageManagerRoot_WithSections(
    $location_id: ID!
    $language: Language!
    $content_list_include_missing: Boolean
  ) {
    PageManagerRoot(location_id: $location_id, language: $language) {
      id
      location_id
      language
      sections {
        ...Fragment_PageManagerSection
      }
    }
  }
  ${Fragment_PageManagerSection}
`;

export const Mutation_UpdatePageManagerRootSections = gql`
  mutation Mutation_UpdatePageManagerRootSections($root_id: ID!, $section_ids: [ID!]!) {
    updatePageManagerRootSections(root_id: $root_id, section_ids: $section_ids) {
      id
    }
  }
`;

export const Mutation_RemovePageManagerRootSection = gql`
  mutation Mutation_RemovePageManagerRootSection($root_id: ID!, $section_id: ID!) {
    removePageManagerRootSection(root_id: $root_id, section_id: $section_id) {
      id
    }
  }
`;

export const Query_AllClasses_PageManager = gql`
  query Query_AllClasses_PageManager($filter: ClassFilter!) {
    allClasses(filter: $filter) {
      id
      title
      full_url
      no_text_image(params: { width: 350, format: webp }) {
        processed_url
      }
    }
  }
`;

export const Query_AllCoupons = gql`
  query Query_AllCoupons(
    $offset: Int
    $limit: Int
    $coupon_code: String
    $coupon_code_contains: String
  ) {
    allCoupons(
      offset: $offset
      limit: $limit
      coupon_code: $coupon_code
      coupon_code_contains: $coupon_code_contains
    ) {
      id
      coupon_code
    }
  }
`;

export const Query_Coupon = gql`
  query Query_Coupon($id: ID!) {
    Coupon(id: $id) {
      ...Fragment_Coupon
    }
  }
  ${Fragment_Coupon}
`;

export const Mutate_CreateCoupon = gql`
  mutation Mutate_CreateCoupon($coupon: CouponInput!) {
    createCoupon(coupon: $coupon) {
      success
    }
  }
`;

export const Mutate_UpdateCoupon = gql`
  mutation Mutate_UpdateCoupon($coupon_id: ID!, $coupon: CouponInput!) {
    updateCoupon(coupon_id: $coupon_id, coupon: $coupon) {
      success
    }
  }
`;

export const Mutate_DeleteCoupon = gql`
  mutation Mutate_DeleteCoupon($coupon_id: ID!) {
    deleteCoupon(coupon_id: $coupon_id) {
      success
    }
  }
`;

export const Mutate_CreateCouponItem = gql`
  mutation Mutate_CreateCouponItem($coupon_item: CouponItemInput!) {
    createCouponItem(coupon_item: $coupon_item) {
      success
    }
  }
`;

export const Mutate_DeleteCouponItem = gql`
  mutation Mutate_DeleteCouponItem($coupon_item_id: ID!) {
    deleteCouponItem(coupon_item_id: $coupon_item_id) {
      success
    }
  }
`;

export const Query_CurrentUser_allCurrentUserCourses_Base = gql`
  query Query_CurrentUser_allCurrentUserCourses_Base(
    $filter: CurrentUserCourseFilter
    $offset: Int!
    $limit: Int!
  ) {
    allCurrentUserCourses(filter: $filter, offset: $offset, limit: $limit) {
      id
      course_id
      recent_activity_date {
        rss
      }
    }
  }
`;

export const Query_CurrentUser_allCurrentUserCourses = gql`
  query Query_CurrentUser_allCurrentUserCourses(
    $filter: CurrentUserCourseFilter
    $offset: Int!
    $limit: Int!
  ) {
    allCurrentUserCourses(filter: $filter, offset: $offset, limit: $limit) {
      id
      course_id
      course {
        id
        title
        access_type
        square_image {
          processed_url
        }
        duration {
          text
        }
        localized_path
        teachers {
          id
          full_name
        }
      }
    }
  }
`;

export const Query_CurrentUser_allCurrentUserCoursesCertificates = gql`
  query Query_CurrentUser_allCurrentUserCoursesCertificates($offset: Int!, $limit: Int!) {
    allCurrentUserCourses(filter: { is_complete: true }, offset: $offset, limit: $limit) {
      id
      course_id
      course {
        ...Fragment_CertificateCard
      }
    }
  }
  ${Fragment_CertificateCard}
`;

export const Query_CourseBundle_CourseModules = gql`
  query Query_CourseBundle_CourseModules($id: ID!) {
    CourseModules(course_id: $id) {
      course_id
      units {
        id
        name
        chapters {
          id
          name
          modules {
            id
            display_name
            snippet(limit: 600)
            module_type
            media_duration {
              seconds
            }
          }
        }
      }
    }
  }
`;

export const Query_CurrentUser_CoursesProgress = gql`
  query Query_CurrentUser_CoursesProgress($ids: [ID!]!) {
    CurrentUserCourses(ids: $ids) {
      id
      course_id
      is_purchased
      completion_percent
    }
  }
`;
